export default {
  lastUpdated: 'Naposledy aktualizováno: {date}',

  layout: {
    label: 'Právní informace',
    toc: 'Na této stránce',
    nav: {
      ariaLabel: 'Právní stránky',
      privacy: 'Zásady ochrany osobních údajů',
      terms: 'Obchodní podmínky',
      cookies: 'Zásady používání souborů cookie',
    },
  },

  privacy: {
    title: 'Zásady ochrany osobních údajů',
    intro: 'Tyto zásady ochrany osobních údajů popisují, jak KeyzoStore shromažďuje, používá a chrání vaše osobní údaje při používání keyzostore.store.',
    sections: {
      dataWeCollect: {
        title: '1. Údaje, které shromažďujeme',
        items: [
          'Údaje o účtu: e-mail, heslo (hashované), volitelné profilové údaje.',
          'Údaje o objednávkách: zakoupené produkty, ceny, záznamy o doručení klíčů.',
          'Platební údaje: zpracovává náš platební zprostředkovatel — údaje o vaší kartě nikdy neuvidíme.',
          'Technické údaje: IP adresa, prohlížeč (user-agent) — pro účely zabezpečení a omezení počtu požadavků.',
        ],
      },
      howWeUseIt: {
        title: '2. Jak je používáme',
        items: [
          'K plnění vašich objednávek a doručování klíčů.',
          'K prevenci podvodů a prosazování našich Obchodních podmínek.',
          'K odesílání transakčních e-mailů (ověření, faktury, obnovení hesla).',
        ],
      },
      sharing: {
        title: '3. Sdílení údajů',
        body: 'Sdílíme pouze to, co je nezbytné: podrobnosti objednávky s naším dodavatelem klíčů (Kinguin) a platební údaje s naším platebním zprostředkovatelem. Vaše údaje neprodáváme.',
      },
      retention: {
        title: '4. Uchovávání údajů',
        body: 'Údaje o účtu jsou uchovávány po dobu existence vašeho účtu. Záznamy o objednávkách mohou být uchovávány déle pro daňové a účetní účely.',
      },
      yourRights: {
        title: '5. Vaše práva',
        body: 'Na základě nařízení GDPR máte právo požádat o přístup, opravu nebo výmaz svých osobních údajů. Pro uplatnění těchto práv kontaktujte podporu.',
      },
      cookies: {
        title: '6. Soubory cookie',
        body: 'Podrobnosti o souborech cookie a sledování naleznete v našich [Zásadách používání souborů cookie](/legal/cookies).',
      },
    },
    fallbackNote: 'Zástupný obsah. Finální právní text čeká na schválení.',
  },

  terms: {
    title: 'Obchodní podmínky',
    intro: 'Tyto Obchodní podmínky upravují vaše používání KeyzoStore (keyzostore.store). Vytvořením účtu nebo provedením nákupu vyjadřujete souhlas s těmito podmínkami.',
    sections: {
      service: {
        title: '1. Služba',
        body: 'KeyzoStore je tržiště, které přeprodává digitální herní klíče od třetích dodavatelů. Klíče jsou doručovány elektronicky — nic se nezasílá fyzicky.',
      },
      eligibility: {
        title: '2. Způsobilost',
        body: 'K používání služby musíte mít alespoň 16 let (nebo věk plnoletosti ve vaší jurisdikci).',
      },
      purchaseDelivery: {
        title: '3. Nákup a doručení',
        body: 'Objednávky podléhají dostupnosti a limitům dodavatele. Klíče jsou uloženy ve vašem účtu po dobu 24 hodin od doručení; uplatněte je prosím co nejdříve.',
      },
      refunds: {
        title: '4. Vrácení peněz',
        body: 'Zásady vrácení peněz se řídí příslušnými předpisy na ochranu spotřebitele. Jakmile si klíč zobrazíte, vrácení peněz zpravidla není možné.',
      },
      accountSecurity: {
        title: '5. Účet a zabezpečení',
        body: 'Jste zodpovědni za zabezpečení svého hesla. Jakýkoli neoprávněný přístup nám neprodleně oznamte.',
      },
      liability: {
        title: '6. Omezení odpovědnosti',
        body: 'V maximálním rozsahu povoleném zákonem KeyzoStore nenese odpovědnost za nepřímé, nahodilé nebo následné škody.',
      },
      changes: {
        title: '7. Změny',
        body: 'Tyto podmínky můžeme aktualizovat. O podstatných změnách vás budeme informovat e-mailem nebo v aplikaci.',
      },
      contact: {
        title: '8. Kontakt',
        body: 'Máte dotazy k těmto podmínkám? Podívejte se do častých dotazů nebo kontaktujte podporu.',
      },
    },
    fallbackNote: 'Zástupný obsah. Finální právní text čeká na schválení.',
  },

  cookies: {
    title: 'Zásady používání souborů cookie a nastavení',
    intro: 'Používáme soubory cookie a podobné technologie k zajištění funkčnosti webu, pochopení způsobu jeho používání a (s vaším souhlasem) k přizpůsobení marketingu.',

    cookiesWeUse: {
      title: 'Soubory cookie, které používáme',
    },

    groups: {
      essential: {
        title: 'Nezbytné',
        tag: 'Vždy zapnuto',
        blurb: 'Nutné pro fungování webu — přihlašování, kontinuita relace a zabezpečení požadavků. Nelze je vypnout.',
        cookies: [
          {
            purpose: 'Uchovává váš krátkodobý přístupový token, abyste zůstali přihlášeni při požadavcích na API i při komunikaci v reálném čase (WebSocket). HttpOnly.',
            expiry: '15 minut',
          },
          {
            purpose: 'Bezpečně obnovuje váš přístupový token, takže vaše relace přetrvá bez nutnosti opětovného přihlášení. HttpOnly.',
            expiry: '30 dní',
          },
          {
            purpose: 'Nastavuje jej Cloudflare na API katalogu Kinguin, které voláme, pro rozlišení důvěryhodného provozu za účelem omezení počtu požadavků a zabezpečení. Nepoužívá se pro reklamu ani sledování mezi weby.',
            expiry: 'Relace (vymazáno po zavření prohlížeče)',
          },
        ],
      },
      analytics: {
        title: 'Analytické',
        tag: 'S vaším souhlasem',
        blurb: 'Pomáhají nám pochopit využívání webu — zobrazení stránek, chyby a kontroly stavu (např. Hotjar). Nastavují se pouze, pokud níže povolíte analytické soubory cookie.',
      },
      marketing: {
        title: 'Marketingové',
        tag: 'S vaším souhlasem',
        blurb: 'Používají se k měření kampaní a personalizaci reklamy (např. Google, Meta). Nastavují se pouze, pokud níže povolíte marketingové soubory cookie.',
      },
    },

    table: {
      cookie: 'Cookie',
      provider: 'Poskytovatel / zdroj',
      purpose: 'Účel',
      type: 'Typ',
      expiry: 'Platnost',
      noCookies: 'V této kategorii zatím nejsou nastaveny žádné soubory cookie.',
    },

    cookieTypes: {
      Session: 'Relační',
      Persistent: 'Trvalý',
    },

    preferences: {
      title: 'Vaše předvolby',
      essential: {
        label: 'Nezbytné',
        description: 'Nutné pro fungování webu.',
      },
      analytics: {
        label: 'Analytické',
        description: 'Pomáhají nám pochopit, jak je web používán.',
      },
      marketing: {
        label: 'Marketingové',
        description: 'Používají se pro personalizovanou reklamu.',
      },
      saved: 'Předvolby uloženy.',
      lastSaved: 'Naposledy uloženo: {date}',
      notSaved: 'Předvolby zatím nebyly uloženy.',
      saveButton: 'Uložit předvolby',
      storageNote: 'Předvolby jsou uloženy v místním úložišti vašeho prohlížeče pod klíčem {code} — vymazáním dat webu dojde k jejich resetování.',
    },

    fallbackNote: 'Tento přehled je průběžně aktualizován se změnami našich integrací. Pokud vám něco přijde neaktuální, kontaktujte podporu.',
  },
};
